import { Seo } from "../components/Seo";
import { Eyebrow, Reveal } from "../components/ui-bits";
import { CTABand, HubCard, Marquee } from "../components/PageSections";
import { OCCASIONS } from "../data/site";

export default function Occasions() {
  return (
    <>
      <Seo
        title="Flower Delivery Coventry RI for Every Occasion | JIF"
        description="Birthday, anniversary, new baby, get well & thank-you flowers designed in Coventry, RI and hand-delivered across Kent County. Call (401) 822-4440."
      />
      <section className="mx-auto max-w-7xl px-5 pb-16 pt-40 sm:px-8">
        <Reveal>
          <Eyebrow>Occasions</Eyebrow>
          <h1 className="mt-5 max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl lg:text-6xl">
            Flowers for Every Occasion
          </h1>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-charcoal/85 sm:text-[18px]">
            From birthdays to just because, every arrangement is designed in our Coventry shop and hand-delivered
            across the Kent County area — same-day in most cases when you call before 3:00 p.m.
          </p>
        </Reveal>
      </section>
      <Marquee />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {OCCASIONS.map((o) => (
            <HubCard
              key={o.path}
              href={o.path}
              image={o.image}
              imageAlt={o.imageAlt}
              eyebrow="Occasions"
              title={o.name}
              blurb={o.lede}
              testid={`occasion-card-${o.slug}`}
            />
          ))}
          <HubCard
            href="/plants-gifts"
            image="https://images.unsplash.com/photo-1558879860-45f24b366ea1?crop=entropy&cs=srgb&fm=jpg&q=85"
            imageAlt="Green and blooming plants at JIF Flowers"
            eyebrow="The Shop"
            title="Plants & Gifts"
            blurb="Green plants, blooming baskets, and dish gardens that keep growing long after the occasion."
            testid="occasion-card-plants-gifts"
          />
        </div>
      </section>
      <CTABand title="Whatever the occasion, start with a call" />
    </>
  );
}
